import axiosInstance from './axiosInstance';
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";
class commonfunction {
    constructor() {
        // console.log(Date.now())
        this.enddate = Date.now();
    }
    getHoursT = (startdate) => {
        const start = new Date(startdate).getTime();
        const end = new Date(Date.now()).getTime();
        //const end = Date.now();
        const timeDifference = (end - start) / 1000;
        const timeDifferenceInHours = Math.abs(Math.round(timeDifference / (60 * 60)));

        return timeDifferenceInHours;
    }

    unlinkfiles = async (arg) => {
        try {
            await axiosInstance.post(`/unlink-files`, arg)
                .then(rs => {
                    console.log(`Sucessfully unline files`, rs);
                }).catch(error => {
                    console.error(`Error:: `, error);
                })
        } catch (error) {
            console.error(`Error:: ${error}`)
        }
    }

    getHours = (startDateString) => {
        const startDate = new Date(startDateString);
        const now = new Date();

        const timeDiffMs = now - startDate;
        const positiveDiffMs = Math.abs(timeDiffMs);

        const days = Math.floor(positiveDiffMs / (1000 * 60 * 60 * 24));
        const hours = Math.floor((positiveDiffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((positiveDiffMs % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((positiveDiffMs % (1000 * 60)) / 1000);

        //const formattedTimeDiff = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        const formattedTimeDiff = hours.toString().padStart(2, '0');
        return formattedTimeDiff;
    }

    getDelay = (endDateString) => {
        const startDate = (endDateString != null) ? new Date(endDateString) : new Date();
        const now = new Date();

        const timeDiffMs = now - startDate;
        console.log(timeDiffMs, startDate, now)
        const positiveDiffMs = Math.abs(timeDiffMs);

        const days = Math.floor(positiveDiffMs / (1000 * 60 * 60 * 24));
        return (timeDiffMs < 0) ? days + " -Days remains" : days + " -Days over";
    }

    convertFirstPageOfPdfToImage = async (pdfUrl) => {
        try {
            const loadingTask = pdfjsLib.getDocument(pdfUrl);
            const pdf = await loadingTask.promise;

            const page = await pdf.getPage(1);
            const viewport = page.getViewport({ scale: 2 });

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");

            canvas.width = viewport.width;
            canvas.height = viewport.height;

            const renderContext = {
                canvasContext: context,
                viewport: viewport,
            };

            const renderTask = page.render(renderContext);
            await renderTask.promise;

            const dataUrl = canvas.toDataURL("image/png");

            // You can now use the image
            return dataUrl;
        } catch (error) {
            console.log("error while converting first page of pdf to image", error)
        }
    };

};

export default new commonfunction();
